exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-wrapper-frame[data-v-317d8898]{width:100%;padding:25px;margin-bottom:15px\n}\n.form-wrapper-frame .md-headline[data-v-317d8898]{margin-bottom:10px\n}\n.md-error[data-v-317d8898]{color:#f44336\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-317d8898","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/distribution/form-components/PublishingForm.vue
// module id = 143
// module chunks = 0